import { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { NotifyFields } from "./NotifyFields";

const BrokerNotifyForm = lazy(() => import("./BrokerNotifyForm"));

/** Top 5 brokers in Germany. Plain text names: no logos, no brand colours. */
const BROKERS = ["Trade Republic", "Scalable Capital", "ING", "comdirect", "DEGIRO"];

const BrokerSync = () => {
  const { t } = useTranslation();
  return (
    <section aria-labelledby="soon-h" className="px-[22px] py-[clamp(80px,8vw,112px)]">
      <div className="pf-rv mx-auto max-w-[1080px] rounded-[32px] border border-foreground/[0.08] bg-white px-6 py-8 shadow-[0_30px_60px_-44px_hsl(var(--foreground)/0.35)] md:p-14">
        <div className="grid grid-cols-1 items-end gap-8 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] lg:gap-16">
          <div>
            <p className="m-0 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.08em] text-pf-amber-ink">
              <span aria-hidden="true" className="h-[7px] w-[7px] rounded-full bg-pf-amber" />
              {t("home.broker.label")}
            </p>
            <h2
              id="soon-h"
              className="mt-4 text-balance text-[clamp(30px,3.4vw,46px)] font-bold leading-[1.06] tracking-[-0.03em]"
            >
              {t("home.broker.title")}
            </h2>
            <p className="mt-4 max-w-[480px] text-[17px] leading-normal text-pf-ink2">{t("home.broker.body")}</p>
          </div>

          <div>
            <Suspense
              fallback={
                <form aria-busy="true" onSubmit={(e) => e.preventDefault()}>
                  <NotifyFields email="" busy={false} />
                </form>
              }
            >
              <BrokerNotifyForm />
            </Suspense>
          </div>
        </div>

        <div className="mt-10 border-t border-foreground/10 pt-6">
          <p className="text-xs font-semibold uppercase tracking-[0.08em] text-pf-ink2">{t("home.broker.brokersLabel")}</p>
          <ul className="m-0 mt-3 flex list-none flex-wrap items-center gap-x-6 gap-y-2 p-0">
            {BROKERS.map((name) => (
              <li key={name} className="text-[17px] font-semibold tracking-[-0.01em] text-foreground">
                {name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default BrokerSync;
